export default class Menu {
  constructor(node) {
    this.node = node

    this.buttonBurger = this.node.querySelector('.menu-button-burger')
    this.buttonClose = this.node.querySelector('.menu-button-close')

    this.headerMenu = this.node.querySelector('.header-menu')

    this.trapFocus = this.trapFocus.bind(this)
    this.clickOpen = this.clickOpen.bind(this)
    this.clickClose = this.clickClose.bind(this)

    this.linksWithSubmenu = Array.from(
      this.headerMenu.querySelectorAll('.menu-item.has-submenu .menu-link')
    )

    this.desktopMenuItemsWithSubmenu = Array.from(
      this.headerMenu.querySelectorAll('.menu-item.has-submenu.menu-display--desktop')
    )
    
    // Set aria-expanded="false" to the first .menu-link item
    this.menuItemsWithSubmenu = Array.from(
      this.headerMenu.querySelectorAll('.menu-item.has-submenu')
    )
    
    this.menuItemsWithSubmenu.forEach(item => {
      const firstLink = item.querySelector('.menu-link')
      if( firstLink ){
        firstLink.setAttribute('role', 'button')
        firstLink.setAttribute('aria-expanded', 'false')
      }
    })

    this.clickToggleSubmenu = this.clickToggleSubmenu.bind(this)

    this.init()
  }

  init() {
    console.debug('  -> Menu init')
    this.reset()
    this.addListeners()
  }

  addHamburgerListener(element, callback) {
    element.addEventListener('click', callback);
    element.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          callback(e)
        }
    })
  }

  addListeners() {
    // Gestione per buttonBurger e buttonClose
    this.addHamburgerListener(this.buttonBurger, this.clickOpen)
    this.addHamburgerListener(this.buttonClose, this.clickClose)

    document.addEventListener('keydown', (e) => {
      if( e.key === 'Escape' ){
        const openDesktopMenu = document.querySelector('.menu-display--desktop.open')

        if( openDesktopMenu ){
          const firstLink = openDesktopMenu.querySelector('.menu-link')

          openDesktopMenu.classList.remove('open')

          if( firstLink ){
              firstLink.setAttribute('aria-expanded', 'false')
              console.log('Closed desktop menu and updated aria-expanded.')
          }
        }
      }
    })

    this.linksWithSubmenu.forEach((item) => {
        item.addEventListener('click', this.clickToggleSubmenu)
    })

    this.desktopMenuItemsWithSubmenu.forEach((item) => {
      const firstLink = item.querySelector('.menu-link')

      const openMenu = () => {
        item.classList.add('open')
        
        if( firstLink ){
          firstLink.setAttribute('aria-expanded', 'true')
        }
      }

      const closeMenu = () => {
        item.classList.remove('open')
        
        if( firstLink ){
          firstLink.setAttribute('aria-expanded', 'false')
        }
      }

      firstLink?.addEventListener('mouseenter', openMenu)
      item.addEventListener('mouseleave', (e) => {
        if( !item.contains(e.relatedTarget) ) {
          closeMenu()
        }
      })

      // firstLink?.addEventListener('focus', openMenu); 
      firstLink?.addEventListener('keydown', openMenu); 
      item.addEventListener('focusout', (e) => {
        if( !item.contains(e.relatedTarget) ) {
          closeMenu()
        }
      })
    })
  }

  clickOpen(e) {
    e.preventDefault()
    document.querySelector('.header').classList.remove('header--hidden')
    this.headerMenu.classList.add('open')
    document.querySelector('html').classList.add('h-noscroll')

    // Waiting for animation to end before setting focus to first focusable element
    const onTransitionEnd = () => {
      const focusableElements = this.headerMenu.querySelectorAll(
        'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
      )
      if( focusableElements.length > 0 ) {
        focusableElements[0].focus()
      }

      this.headerMenu.removeEventListener('transitionend', onTransitionEnd)
    }

    this.headerMenu.addEventListener('transitionend', onTransitionEnd)

    document.addEventListener('keydown', this.trapFocus)
  }

  clickClose(e) {
    e.preventDefault()
    this.headerMenu.classList.remove('open')
    document.querySelector('html').classList.remove('h-noscroll')
    document.removeEventListener('keydown', this.trapFocus)

    document.querySelectorAll('.has-submenu.menu-display--mobile').forEach((element) => {
      element.classList.remove('show')
    })
  }

  clickToggleSubmenu(e) {
    // e.preventDefault()
    const parentElement = e.target.parentElement

    if( parentElement.classList.contains('menu-display--mobile') ) {
      parentElement.classList.toggle('show')

      // Get aria-expanded current value
      const isExpanded = e.target.getAttribute('aria-expanded') === 'true'

      // aria-expanded toggle
      e.target.setAttribute('aria-expanded', !isExpanded)
    }
  }

  trapFocus(e) {
    const focusableElements = this.headerMenu.querySelectorAll(
      'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
    )
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1]

    if( e.key === 'Tab' ) {
      if( e.shiftKey ){
        if( document.activeElement === firstElement ) {
          e.preventDefault()
          lastElement.focus()
        }
      } else {
        if( document.activeElement === lastElement ) {
          e.preventDefault()
          firstElement.focus()
        }
      }
    }

    if( e.key === 'Escape' ){
      this.clickClose(e)
    }
  }

  reset() {
    console.debug('  -> Menu reset')

    this.linksWithSubmenu.forEach((item) => {
      item.parentElement.classList.remove('show')
    })
    this.headerMenu.classList.remove('open')
    document.querySelector('html').classList.remove('h-noscroll')
  }

  static destroy() {
    console.debug('  -> Menu destroy')

    this.reset()

    this.buttonBurger.removeEventListener('click', this.clickOpen)
    this.buttonClose.removeEventListener('click', this.clickClose)

    this.linksWithSubmenu.forEach((item) => {
      item.removeEventListener('click', this.clickToggleSubmenu)
    })
  }

  static init() {
    console.debug('== Menu component ==')
    Menu.item = new Menu(document.querySelector('.header'))
  }
}
